
import { Component, Vue } from "vue-property-decorator";

@Component
export class PLoading extends Vue {}
export default PLoading;
